import { TheftProtection } from '@catalogo/ui-americanas-mobile-theft-protection';

export default TheftProtection;
